import * as R from "../ramda";
export { isPlural, isSingular, plural as pluralize, singular as singularize } from 'pluralize';
export { default as uuid } from 'uuid/v4';
export * from "../async";
export { default as traverseJSON } from "./traverseJSON";
export const throwWhen = conditionMessageZips => value => {
  // eslint-disable-next-line functional/no-expression-statement
  R.forEach(([condition, getMessage]) => {
    // eslint-disable-next-line functional/no-conditional-statement
    if (condition(value)) {
      // eslint-disable-next-line functional/no-throw-statement
      throw Error(JSON.stringify(getMessage(value)));
    }
  }, conditionMessageZips);
  return value;
}; // export const throwInvalid = <T>(conditionMessageZips: ConditionMessageZip<T>[], value: any) => {
//   // eslint-disable-next-line functional/no-expression-statement
//   R.forEach(([condition, message]: ConditionMessageZip<T>) => {
//     // eslint-disable-next-line functional/no-conditional-statement
//     if (!condition(value)) {
//       // eslint-disable-next-line functional/no-throw-statement
//       throw Error(JSON.stringify(message))
//     }
//   }, conditionMessageZips)
//   return value
// }

export const upperFirst = R.pipe(R.split(''), R.over(R.lensIndex(0), R.toUpper), R.join(''));
export const lowerFirst = R.pipe(R.split(''), R.over(R.lensIndex(0), R.toLower), R.join(''));
export const camelCase = str => str.replace(/[-_]([a-z])/g, m => upperFirst(m));
export const noCase = str => {
  const hasSpace = /\s/;
  const hasSeparator = /(_|-|\.|:)/;
  const hasCamel = /([a-z][A-Z]|[A-Z][a-z])/;
  const separatorSplitter = /[\W_]+(.|$)/g;
  const camelSplitter = /(.)([A-Z]+)/g;

  const unseparate = value => value.replace(separatorSplitter, (m, next) => next ? ` ${next}` : '');

  const uncamelize = value => value.replace(camelSplitter, (m, previous, uppers) => `${previous} ${uppers.toLowerCase().split('').join(' ')}`);

  return R.cond([[R.always(hasSpace.test(str)), R.always(str.toLowerCase())], [R.always(hasSeparator.test(str)), R.always((unseparate(str) || str).toLowerCase())], [R.always(hasCamel.test(str)), R.always(uncamelize(str).toLowerCase())], [R.T, R.always(str.toLowerCase())]])(str); // if (hasSpace.test(str)) return str.toLowerCase()
  // if (hasSeparator.test(str)) return (unseparate(str) || str).toLowerCase()
  // if (hasCamel.test(str)) return uncamelize(str).toLowerCase()
  // return str.toLowerCase()
};
export const spaceCase = str => noCase(str).replace(/[\W_]+(.|$)/g, (matches, match) => match ? ` ${match}` : '').trim();
export const snakeCase = str => spaceCase(str).replace(/\s/g, '_');
export const words = regex => value => R.split(regex !== null && regex !== void 0 ? regex : /[^A-Za-z0-9]/g, value);
export const isNumberString = value => R.test(/^\d+$/, value);
export const log = message => value => {
  // eslint-disable-next-line functional/no-expression-statement
  console.log(`
message:${JSON.stringify(message)},
value: ${JSON.stringify(value)}
`);
  return value;
};
export const logMessage = message => value => {
  // eslint-disable-next-line functional/no-expression-statement
  console.log(`message:${JSON.stringify(message)}`);
  return value;
};
export const isError = value => value instanceof Error;
export const isNotError = value => !(value instanceof Error);
export const pickAllPaths = paths => R.pipe(R.paths(paths), R.zip(paths), R.reduce((acc, [pathList, value]) => R.assocPath(pathList, value, acc), {}));
export const pickPaths = paths => R.pipe(R.paths(paths), R.zip(paths), R.reduce((acc, [pathList, value]) => R.ifElse(R.isNotNil, R.always(R.assocPath(pathList, value, acc)), R.always(acc))(value), {}));
export const regex = regularExpression => text => {
  let m;
  const results = [];

  while ((m = regularExpression.exec(text)) !== null) {
    // This is necessary to avoid infinite loops with zero-width matches
    if (m.index === regularExpression.lastIndex) {
      regularExpression.lastIndex++;
    }

    const newMatch = {
      match: '',
      groups: []
    }; // The result can be accessed through the `m`-variable.

    m.forEach((match, groupIndex) => {
      if (groupIndex === 0) {
        newMatch.match = match;
        results.push(newMatch);
      } else {
        newMatch.groups.push(match);
      }
    });
  }

  return results;
};
export const between = (min, max) => item => R.pipe(R.min(max), R.max(min))(item);
export const pace = (index, count) => list => {
  const move = index + count;
  const length = R.length(list || []);
  return R.move(index, between(0, length - 1)(move), list);
};
export const equalsExclude = exclude => (item, otherItem) => R.ifElse(R.isPlainObject, () => R.equals(R.omitBy(val => exclude(val))(item), R.omitBy(val => exclude(val))(otherItem)), () => R.equals(item, otherItem))(item);
const defaultIndexedFilter = R.addIndex(R.filter);
export const filterIndexed = iterator => list => defaultIndexedFilter(iterator)(list);
const defaultIndexedReject = R.addIndex(R.reject);
export const rejectIndexed = iterator => list => defaultIndexedReject(iterator)(list);
export const toJSONItemList = jsonObject => R.pipe(R.mapObjIndexed((value, key) => R.cond([[R.is(Object), () => ({
  key,
  properties: toJSONItemList(value)
})], [R.T, () => ({
  key,
  value
})]])(value)), R.values)(jsonObject);
export const mergeDeepAll = list => R.reduce(R.mergeDeepRight, // @ts-ignore
{})(list);
export const toMongoQuery = (data, config = {}) => {
  const {
    processItem,
    path = []
  } = config;
  return R.ifElse(R.isPlainObject, () => R.pipe(R.mapObjIndexed((value, key) => {
    const currentPath = [...path, key];
    const result = processItem === null || processItem === void 0 ? void 0 : processItem(value, currentPath);
    const innerResult = result ? toMongoQuery(result, {
      path: currentPath,
      processItem
    }) : R.ifElse(() => R.startsWith('$')(key), () => buildDataForMongoQuery({
      [key]: value
    }, path), () => toMongoQuery(value, {
      path: currentPath,
      processItem
    }))(key);
    return innerResult;
  }), R.values, list => mergeDeepAll(list))(data), () => buildDataForMongoQuery(data, path))(data);
};

const buildDataForMongoQuery = (value, path) => R.isEmptyArray(path) ? value : {
  [R.join('.')(path)]: value
};